{
  "CookiesDescription": "Wir verwenden Cookies, um Ihre Erfahrung mit Akixi zu verbessern. Weitere Informationen darüber, wie und warum wir Cookies verwenden, finden Sie in unserer {}Cookie-Richtlinie{}.",
  "CookieConsentChangeMessage": "Wenn Sie diese Einstellung ändern möchten, können Sie dies unten tun.",
  "AcceptedAllCookiesMessage": "Sie haben alle Cookies akzeptiert.\n {}",
  "AcceptedFunctionalCookiesMessage": "Sie haben nur Funktionscookies akzeptiert.\n {}",
  "RejectedAllCookiesMessage": "Sie haben alle Cookies abgelehnt. Dies bedeutet, dass einige Funktionen der Anwendung nicht funktionieren.\n {}",
  "AcceptAllCookies": "Akzeptiere alle",
  "AcceptFunctionalityCookies": "Funktionalitäts-Cookies akzeptieren",
  "RevokeAllCookies": "Alle Einwilligungen widerrufen",
  "RevokeStatisticsCookies": "Statistikeinwilligung widerrufen",
  "RejectAllCookies": "Alles ablehnen",
  "RejectionWarning": "Wenn Sie alle Cookies ablehnen, können Sie möglicherweise nicht alle Funktionen der Anwendung nutzen. \n\n Wenn Sie diese Funktionen in Zukunft verwenden möchten, müssen Sie auf der Seite Cookie-Richtlinie \"Funktionscookies akzeptieren\".",
  "NAME": "CookieConsent"
}